function Theme(Vue) {
    this.route = route
}
Theme.prototype = {
    homeTheme: {
        hdBg: '#FDFDFA',
        cntBg: '#FDFDFA',
        fotBg: 'rgb(118, 172, 206)',
        fotText: 'rgb(31, 39, 58)',
        hdHeight: 'auto',
    },
    blogTheme: {
        hdBg: 'white',
        cntBg: 'white',
        fotBg: 'rgb(118, 172, 206)',
        fotText: 'rgb(31, 39, 58)',
    },
    prodIndexTheme: {
        hdBg: 'white',
        cntBg: 'white',
        fotBg: 'rgb(118, 172, 206)',
        fotText: 'rgb(31, 39, 58)',
    },
    prodDetailTheme: {
        hdHeight: '100px',
        hdBg: 'white',
        cntBg: 'url("/img/products/detail/bg2.svg")',
        fotBg: 'rgb(118, 172, 206)',
        fotText: 'rgb(31, 39, 58)',
    },
    shopCartTheme: {
        hdBg: 'white',
        hdHeight: '300px',
        cntBg: 'url("/img/products/detail/bg2.svg")',
        fotBg: 'rgb(118, 172, 206)',
        fotText: 'rgb(31, 39, 58)',
    },
    instruTheme: {
        hdBg: 'white',
        cntBg: 'url("/img/introd/Instrumentation/bg.svg")',
        fotBg: 'rgb(118, 172, 206)',
        fotText: 'rgb(31, 39, 58)',
        sdoper: '#6199aa',
        bubbles: ['rgb(213, 234, 243)', 'rgb(182, 219, 234)', 'rgb(158, 207, 228)'],
        bubbline: '#2d5c6b',
    },
    pepreagentTheme: {
        hdBg: 'white',
        cntBg: 'url("/img/introd/PeptideReagent/cntbg.svg")',
        fotBg: 'rgb(118, 172, 206)',
        fotText: 'rgb(31, 39, 58)',
        sdoper: '#6199aa',
        bubbles: ['rgb(213, 234, 243)', 'rgb(182, 219, 234)', 'rgb(158, 207, 228)'],
        bubbline: '#2d5c6b',
    },
    peptideTheme: {
        hdBg: 'white',
        cntBg: 'url("/img/introd/peptide/cntbg.svg")',
        fotBg: 'rgb(118, 172, 206)',
        fotText: 'rgb(31, 39, 58)',
        sdoper: '#6199aa',
        bubbles: ['rgb(213, 234, 243)', 'rgb(182, 219, 234)', 'rgb(158, 207, 228)'],
        bubbline: '#2d5c6b',
    },
    qualityassuranceTheme: {
        hdBg: 'white',
        cntBg: '',
        fotBg: 'rgb(118, 172, 206)',
        fotText: 'rgb(31, 39, 58)',
        sdoper: '#6199aa',
        bubbles: ['rgb(213, 234, 243)', 'rgb(182, 219, 234)', 'rgb(158, 207, 228)'],
        bubbline: '#2d5c6b',
    },
    prehplcandcolumnTheme: {
        hdBg: 'white',
        cntBg: '',
        fotBg: 'rgb(118, 172, 206)',
        fotText: 'rgb(31, 39, 58)',
        sdoper: '#6199aa',
        bubbles: ['rgb(213, 234, 243)', 'rgb(182, 219, 234)', 'rgb(158, 207, 228)'],
        bubbline: '#2d5c6b',
    },
    agentTheme: {
        hdBg: 'white',
        cntBg: 'white',
        fotBg: 'rgb(118, 172, 206)',
        fotText: 'rgb(31, 39, 58)',
        sdoper: '#6199aa',
        bubbles: ['rgb(213, 234, 243)', 'rgb(182, 219, 234)', 'rgb(158, 207, 228)'],
        bubbline: '#2d5c6b',
    },
    newProdTheme: {
        hdBg: 'white',
        cntBg: 'white',
        fotBg: 'rgb(118, 172, 206)',
        fotText: 'rgb(31, 39, 58)',
        sdoper: '#6199aa',
        bubbles: ['rgb(213, 234, 243)', 'rgb(182, 219, 234)', 'rgb(158, 207, 228)'],
        bubbline: '#2d5c6b',
    },
    userEntryTheme: {
        hdHeight: '64px',
        hdBg: 'white',
        cntBg: 'white',
        fotBg: 'rgb(118, 172, 206)',
        fotText: 'rgb(31, 39, 58)',
    }
}

Theme.prototype = Object.assign(Theme.prototype, {
    home: Theme.prototype.homeTheme,
    'f|blog|index': Theme.prototype.blogTheme,
    'f|products|index': Theme.prototype.prodIndexTheme,
    'f|products|detail': Theme.prototype.prodDetailTheme,
    'f|shop|cart|index': Theme.prototype.shopCartTheme,
    'f|shop|cart|checkout': Theme.prototype.shopCartTheme,
    'f|shop|cart|success': Theme.prototype.shopCartTheme,
    'f|shop|order|ls': Theme.prototype.shopCartTheme,
    'f|shop|order|detail': Theme.prototype.shopCartTheme,
    'f|user|info|index': Theme.prototype.shopCartTheme,
    'f|introd|instru|newcsbio': Theme.prototype.instruTheme,
    'f|introd|instru|cs136series': Theme.prototype.instruTheme,
    'f|introd|instru|cs536series': Theme.prototype.instruTheme,
    'f|introd|instru|cs936series': Theme.prototype.instruTheme,
    'f|introd|instru|dnarnasynthesizer': Theme.prototype.instruTheme,
    'f|introd|pepreagent|aminoacidsandresins': Theme.prototype.pepreagentTheme,
    'f|introd|pepreagent|aminoacidcartridges': Theme.prototype.pepreagentTheme,
    'f|introd|pepreagent|finechemicals': Theme.prototype.pepreagentTheme,
    'f|introd|pepreagent|reagentfordnarnasynthesizer': Theme.prototype.pepreagentTheme,
    'f|introd|peptide|popularpeptides': Theme.prototype.peptideTheme,
    'f|introd|peptide|gmppeptideproduction': Theme.prototype.peptideTheme,
    'f|introd|peptide|custommanufacturedpeptides': Theme.prototype.peptideTheme,
    'f|introd|peptide|petpepticeandprettypep': Theme.prototype.peptideTheme,
    'f|introd|peptide|covid19introd': Theme.prototype.peptideTheme,
    'f|introd|qualityassurance|qualityassurance': Theme.prototype.qualityassuranceTheme,
    'f|introd|qualityassurance|csbioanalyticalservices': Theme.prototype.qualityassuranceTheme,
    'f|introd|prehplcandcolumn|prephplcsys': Theme.prototype.prehplcandcolumnTheme,
    'f|introd|prehplcandcolumn|semiprephplcsys': Theme.prototype.prehplcandcolumnTheme,
    'f|introd|prehplcandcolumn|pilotprehplcsys': Theme.prototype.prehplcandcolumnTheme,
    'f|introd|prehplcandcolumn|industrialprephplcsys': Theme.prototype.prehplcandcolumnTheme,
    'f|introd|agent|index': Theme.prototype.agentTheme,
    'f|introd|newprod|index': Theme.prototype.newProdTheme,
    'f|user|entry|page|login': Theme.prototype.userEntryTheme,
    'f|user|entry|page|register': Theme.prototype.userEntryTheme,
    'f|user|entry|page|forget': Theme.prototype.userEntryTheme,
    'f|user|entry|change': Theme.prototype.userEntryTheme,
    'f|contactus|index': Theme.prototype.shopCartTheme,
    'f|career|index': Theme.prototype.shopCartTheme,
    'f|ourhonor|index': Theme.prototype.shopCartTheme,
    'f|antibodyprod|index': Theme.prototype.shopCartTheme,
    'f|antibodyprod|detail': Theme.prototype.shopCartTheme,
    getCurTheme() {
        if(!this.route().current())
            return {}
        return Theme.prototype[this.route().current().replace(/\./g, '|')]
    },
})

export default Theme
